import { render, staticRenderFns } from "./detentionInvoiceEdit.vue?vue&type=template&id=bbe53b40"
import script from "./detentionInvoiceEdit.vue?vue&type=script&lang=js"
export * from "./detentionInvoiceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports